import { AccountProvider, Client } from '@collinsonx/constants/enums';
import useLocale from 'hooks/useLocale';

import usePayload from './usePayload';

export const useCustomBrandName = () => {
  const { payload } = usePayload();
  const translations = useLocale();
  const { accountProvider, membershipType } = payload ?? {};

  if (membershipType && membershipType === Client.Mastercard_MCAE)
    return translations.generic.branding.MCAECustomBrandName;

  switch (accountProvider) {
    case AccountProvider.LK:
      return 'Lounge Key';
    case AccountProvider.PP:
    case AccountProvider.PP_PREFERRED:
      return 'Priority Pass';
    default:
      return 'Priority Pass';
  }
};
